"use strict";

var _slicedToArray = require("/codebuild/output/src305412778/src/github.com/rteamweb/web-marketing-ui/application/node_modules/@babel/runtime/helpers/slicedToArray.js");

var _taggedTemplateLiteral = require("/codebuild/output/src305412778/src/github.com/rteamweb/web-marketing-ui/application/node_modules/@babel/runtime/helpers/taggedTemplateLiteral.js");

var _templateObject, _templateObject2, _templateObject3, _templateObject4;

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var jsx_runtime_1 = require("@emotion/react/jsx-runtime");

var react_1 = require("react");

var styled_1 = __importDefault(require("@emotion/styled"));

var frontend_form_controls_1 = require("@ryerson/frontend.form-controls");

var frontend_layout_1 = require("@ryerson/frontend.layout");

var frontend_common_1 = require("@ryerson/frontend.common");

var frontend_theme_1 = require("@ryerson/frontend.theme");

var frontend_button_1 = require("@ryerson/frontend.button");

var KeywordSearchResults_1 = __importDefault(require("../../SearchResults/KeywordSearchResults"));

var frontend_application_1 = require("@ryerson/frontend.application");

var react_2 = require("@emotion/react");

var Utils_1 = require("./Utils");

var FullStructuredHeader_1 = require("../FullStructuredHeader");

var util_1 = require("../../common/Contentful/util");

var frontend_e_commerce_1 = require("@ryerson/frontend.e-commerce");

var SearchResults_v2_1 = require("../../SearchResults_v2");

var SearchResultsContext_v2_1 = require("../../SearchResults_v2/SearchResultsContext_v2");

var SearchBar = styled_1.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n\theight: 50px;\n\t", ";\n"])), function (props) {
  var bgColor = props.bgColor;
  return (0, react_2.css)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n\t\t\tbackground: ", ";\n\t\t"])), bgColor);
});
var SearchInputStyled = (0, styled_1.default)(frontend_form_controls_1.SearchInput)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n\twidth: 100%;\n\tinput {\n\t\theight: 30px;\n\t}\n"])));
var barWrapperStyles = (0, react_2.css)(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n\twidth: 95%;\n"])));

var MobileSearch = function MobileSearch(_ref) {
  var language = _ref.language,
      onClose = _ref.onClose,
      storeDirectory = _ref.storeDirectory;

  var _ref2 = (0, frontend_application_1.useApplication)(),
      axiosInstance = _ref2.axiosInstance,
      isLoggedIn = _ref2.user.isLoggedIn,
      zipCode = _ref2.zipCode;

  var _ref3 = (0, frontend_e_commerce_1.useEcommerce)(),
      defaultShipToAddress = _ref3.defaultShipToAddress,
      selectedShipToAddress = _ref3.selectedShipToAddress;

  var searchInputRef = (0, react_1.useRef)();
  var searchResultsRef = (0, react_1.useRef)();

  var _ref4 = (0, react_1.useState)(),
      _ref5 = _slicedToArray(_ref4, 2),
      searchResults = _ref5[0],
      setSearchResults = _ref5[1];

  var _ref6 = (0, react_1.useState)(false),
      _ref7 = _slicedToArray(_ref6, 2),
      trigger = _ref7[0],
      setTrigger = _ref7[1];

  var _ref8 = (0, react_1.useState)(false),
      _ref9 = _slicedToArray(_ref8, 2),
      searchFinished = _ref9[0],
      setSearchFinished = _ref9[1];

  var _ref10 = (0, react_1.useState)(""),
      _ref11 = _slicedToArray(_ref10, 2),
      searchText = _ref11[0],
      setSearchText = _ref11[1];

  var _ref12 = (0, react_1.useState)(),
      _ref13 = _slicedToArray(_ref12, 2),
      keywordSearchResults = _ref13[0],
      setKeywordSearchResults = _ref13[1];

  var _ref14 = (0, react_1.useState)(false),
      _ref15 = _slicedToArray(_ref14, 2),
      isKeywordSearch = _ref15[0],
      setIsKeywordSearch = _ref15[1];

  var debouncedSearchInput = searchText.toString();
  var debouncedSearchTerm = (0, frontend_common_1.useDebounce)(debouncedSearchInput, 500);
  var searchKeywordsMap = (0, Utils_1.getSearchKeywordsConfig)(storeDirectory)[language];
  var keywords = Object.keys(searchKeywordsMap);
  (0, react_1.useEffect)(function () {
    var _a;

    var searchTermLength = (_a = searchText.toString().trim().length) !== null && _a !== void 0 ? _a : 0;

    if (searchTermLength < FullStructuredHeader_1.HEADER_SEARCH_MIN_LENGTH) {
      setSearchResults(undefined);
    }

    if (searchTermLength >= FullStructuredHeader_1.HEADER_SEARCH_MIN_LENGTH && debouncedSearchTerm === searchText) {
      var searchWords = searchText.toString().trim().toLowerCase().split(" ");

      if (keywords.includes(searchWords[0])) {
        setIsKeywordSearch(true);
        setSearchResults(undefined);
        setKeywordSearchResults({
          keyword: searchWords[0],
          payload: searchWords.length > 1 ? searchWords[1] : ""
        });
      } else {
        var searchPhrase = searchText.toString().trim();
        var params = {
          "search-phrase": searchPhrase,
          language: language,
          limit: FullStructuredHeader_1.HEADER_SEARCH_LIMIT,
          "zip-code": !isLoggedIn ? zipCode : (0, frontend_common_1.formatZipCode)(selectedShipToAddress ? selectedShipToAddress.zipCode : (defaultShipToAddress === null || defaultShipToAddress === void 0 ? void 0 : defaultShipToAddress.zipCode) || zipCode)
        };
        setSearchFinished(false);
        var searchEventParams = {
          action: "browse",
          value: searchPhrase
        };
        axiosInstance.get(frontend_common_1.ApiUrl.GLOBAL_SEARCH_V2, {
          params: params,
          paramsSerializer: util_1.encodeSearchQueryParams
        }).then(function (response) {
          var _a;

          var responseData = response === null || response === void 0 ? void 0 : response.data;

          if (responseData) {
            setSearchFinished(true);
            setSearchResults(responseData);
            (_a = searchInputRef.current) === null || _a === void 0 ? void 0 : _a.focus();
          } else {// setIsError(true);
          }

          (0, frontend_common_1.sendGAEvent)(frontend_common_1.GoogleAnalyticsEventName.ITEM_SEARCH, searchEventParams);
        }).catch(function () {//setIsError(true);
        });
        setTrigger(!trigger);
      }
    }
  }, [debouncedSearchTerm]);
  (0, react_1.useEffect)(function () {
    var _a;

    (_a = searchInputRef.current) === null || _a === void 0 ? void 0 : _a.focus();
  }, [trigger]);
  (0, react_1.useEffect)(function () {
    if (searchFinished) {
      setTimeout(function () {
        var _a, _b;

        var container = document.querySelector(".accordion-search");

        if (container) {
          var el = container.querySelector("span");
          var contentContainer = (_b = (_a = el === null || el === void 0 ? void 0 : el.parentNode) === null || _a === void 0 ? void 0 : _a.parentNode) === null || _b === void 0 ? void 0 : _b.querySelector("div[data-expanded]");
          var isExpanded = contentContainer && contentContainer.dataset.expanded === "true";

          if (!isExpanded) {
            el && el.click();
          }
        }
      }, 0);
    }
  }, [searchFinished]);

  var _ref16 = (0, frontend_theme_1.useTheme)(),
      theme = _ref16.theme;

  var darkGray = theme.colors.primary.darkGray;

  var handleReset = function handleReset() {
    setSearchText("");
    setIsKeywordSearch(false);
    setKeywordSearchResults(undefined);
    setSearchResults(undefined);
  };

  var showMoreProducts_v2 = function showMoreProducts_v2() {
    sessionStorage.setItem(frontend_common_1.SessionItems.displaySearchText, debouncedSearchInput);
    return "".concat(storeDirectory, "/search");
  };

  return (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, {
    children: [(0, jsx_runtime_1.jsx)(SearchBar, {
      bgColor: darkGray,
      children: (0, jsx_runtime_1.jsxs)(frontend_layout_1.Flex, {
        css: {
          height: "100%"
        },
        justifyContent: "space-between",
        alignContent: "center",
        alignItems: "center",
        children: [(0, jsx_runtime_1.jsx)(frontend_layout_1.Flex, {
          justifyContent: "center",
          alignItems: "center",
          style: barWrapperStyles,
          children: (0, jsx_runtime_1.jsx)(frontend_layout_1.FlexItem, {
            style: barWrapperStyles,
            children: (0, jsx_runtime_1.jsx)(SearchInputStyled, {
              size: "sm",
              shape: "rounded",
              language: language,
              value: searchText,
              inputRef: searchInputRef,
              icon: searchText ? "close" : undefined,
              onIconClick: handleReset,
              iconBackgroundColor: searchText ? theme.colors.primary.gray : "",
              iconPosition: "right",
              onChange: function onChange(e) {
                var value = e.target.value;
                setSearchText(value);
                setTrigger(!trigger);
              }
            })
          })
        }), (0, jsx_runtime_1.jsx)(frontend_button_1.Button, {
          background: darkGray,
          rightIcon: "close",
          foreground: "light",
          label: "",
          onClick: function onClick() {
            handleReset();
            onClose();
          }
        })]
      })
    }), searchText.toString().length > 0 && !isKeywordSearch && (searchResults === null || searchResults === void 0 ? void 0 : searchResults.matchingProducts) && (0, jsx_runtime_1.jsx)(SearchResultsContext_v2_1.SearchResultsProvider, {
      results: searchResults,
      showMoreProducts: showMoreProducts_v2,
      isMobile: true,
      itemRef: searchResultsRef,
      storeDirectory: storeDirectory,
      isKeywordSearch: isKeywordSearch,
      setSearchText: setSearchText,
      children: (0, jsx_runtime_1.jsx)(SearchResults_v2_1.SearchResults_v2, {})
    }), searchText.toString().length > 0 && isKeywordSearch && (keywordSearchResults === null || keywordSearchResults === void 0 ? void 0 : keywordSearchResults.keyword) && (0, jsx_runtime_1.jsx)(KeywordSearchResults_1.default, {
      isMobile: true,
      isSticky: false,
      results: keywordSearchResults,
      keywordsConfig: (0, Utils_1.getSearchKeywordsConfig)(storeDirectory)
    })]
  });
};

exports.default = MobileSearch;